<template>
  <div>
    <div v-show="selectPosition" class="map">
      <iframe
        id="mapPage"
        width="100%"
        height="100%"
        frameborder="0"
        :src="poiSelectURL"
      >
      </iframe>
    </div>
    <div v-show="!selectPosition">
      <div class="page_title">网点详情</div>
      <div class="form_container">
        <form class="form">
          <div class="form_row">
            <div class="label">网点名称</div>
            <input class="input" placeholder="网点名称" v-model="posName" />
          </div>
          <div class="form_row align-center">
            <div class="label">所属商家</div>
            <el-select class="formSelect" v-model="partnerId">
              <el-option
              v-for="item of partnerList"
              :key="item.id"
              :value="item.partnerId"
              :label="item.name"></el-option>
            </el-select>
          </div>
          <div class="form_row">
            <div class="label">网点来源</div>
            <input class="input" placeholder="网点来源" v-model="fromnode" />
          </div>
          <div class="form_row align-center">
            <div class="label">接入类型</div>
            <el-select class="formSelect" v-model="accessType">
              <el-option
                v-for="item of accessTypeList"
                :key="item.id"
                :value="item.id"
                :label="item.name">
              </el-option>
            </el-select>
          </div>
          <div class="form_row align-center">
            <div class="label">调用方式</div>
            <el-select class="formSelect" v-model="callMethod" placeholder="请选择调用方式">
              <el-option
              v-for="item in callMethods"
              :key="item.id"
              :label="item.name"
              :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="form_row align-center">
            <div class="label">省市区</div>
            <div class="form_value">
              <el-select
                class="pullDown"
                @change="changeProvince"
                v-model="currentProvince">
                <el-option
                  v-for="(item, index) of provinces"
                  :key="index"
                  :value="item.name"
                  :label="item.name">
                </el-option>
              </el-select>
              <el-select
                class="pullDown"
                @change="changeCity"
                v-model="currentCity">
                <el-option
                  v-for="(item, index) of citys"
                  :key="index"
                  :value="item.name"
                  :label="item.name">
                </el-option>
              </el-select>
              <el-select
                class="pullDown"
                v-model="currentDistrict">
                <el-option
                  v-for="(item, index) of districts"
                  :key="index"
                  :value="item"
                  :label="item">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="form_row">
            <div class="label">地址</div>
            <input class="input" placeholder="地址" v-model="address" />
          </div>
          <div class="form_row">
            <div class="label">经纬度</div>
            <div class="form_value">
              <input
                class="input_left"
                placeholder="经度"
                v-model="longitude"
              />
              <span style="font-size: 18px">，</span>
              <input
                class="input_right"
                placeholder="纬度"
                v-model="latitude"
              />
              <i class="bi bi-geo-alt-fill" @click="fillPosition"></i>
            </div>
          </div>
          <div class="form_row">
            <div class="label_imgload">网点二维码</div>
            <div class="imgUpload">
              <van-uploader v-model="cacheDeliveryUrl" max-count="1" :after-read="complateImg" @delete="deletDeliveryUrlImg" multiple/>
            </div>
          </div>

          <div class="form_row">
            <div class="label_imgload">二维码url</div>
            <div class="add_qrcode_container flex-col align-center">
              <div class="qrcode_container flex-row align-center" v-for="(item,index) of listQrInfo" :key="index">
                <input type="text" class="qrcode_input" :value="item" readonly>
<!--                <div class="deleteQrcode_container justify-center align-center" @click="deletQrCodeUrl(index)">
                  <van-icon class="deleteQrcode" name="cross" />
                </div>-->
              </div>
              <van-button type="info" class="add_qrcode_url" @click="scanQrCode">扫一扫，增加二维码</van-button>
            </div>
          </div>

          <div class="form_row">
            <div class="label_imgload">网点照片</div>
            <div class="imgUpload">
              <van-uploader
                v-model="posImgs"
                multiple
                @click-upload="getUploadImg(true)"
                @delete="deletImg"
              />
            </div>
          </div>
          <div class="form_row">
            <div class="label">联系人</div>
            <input class="input" placeholder="联系人" v-model="contact" />
          </div>
          <div class="form_row">
            <div class="label">联系电话</div>
            <input
              class="input"
              type="number"
              placeholder="联系电话"
              v-model="phone"
            />
          </div>
          <div class="form_row">
            <div class="label">营业时间</div>
            <!--          <input class="input" placeholder="营业时间" v-model="openHours">-->
            <div class="timeGrounp">
              <input
                id="beginHours"
                class="timeItem"
                style="margin-left: 10px"
                type="text"
                maxlength="2"
                onkeyup="value=value.replace(/\D/g,'')"
                v-model="beginHours"
              />
              <span class="intervalFont">:</span>
              <input
                id="beginMin"
                class="timeItem"
                type="text"
                maxlength="2"
                onkeyup="value=value.replace(/\D/g,'')"
                v-model="beginMin"
              />
              <span class="intervalFont">-</span>
              <input
                id="endHours"
                class="timeItem"
                type="text"
                maxlength="2"
                onkeyup="value=value.replace(/\D/g,'')"
                v-model="endHours"
              />
              <span class="intervalFont">:</span>
              <input
                id="endMin"
                class="timeItem"
                type="text"
                maxlength="2"
                onkeyup="value=value.replace(/\D/g,'')"
                v-model="endMin"
              />
            </div>
          </div>

          <div class="form_row">
            <div class="label">设备名称<br />(IMEI号)</div>
            <input class="input" placeholder="设备序号" v-model="deviceName" />
          </div>
          <div class="form_row">
            <div class="label">所属商户设备序号</div>
            <input
              class="input"
              placeholder="所属商户设备序号"
              v-model="snOfPartnerId"
            />
          </div>
          <div class="form_row">
            <div class="label">设备token</div>
            <input
              class="input"
              placeholder="设备token"
              v-model="deviceToken"
            />
          </div>
          <div class="form_row">
            <div class="label">pubKey</div>
            <input
              class="input"
              placeholder="pubKey"
              v-model="pubKey"
            />
          </div>
          <div class="button_container">
            <a
              href="javascript:"
              role="button"
              class="weui-btn weui-btn_primary"
              @click="submitPos"
              >确认</a
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { getArea, addPos, modPos, modPosPartner } from "../api";
import { uploadImg, createUploadImgName, findMatch,deletImgObject } from "../util";
import {getPartnerList, queryPosDetailByPosId, findPartnerByPartnerId, queryQrInfo} from "../graphql/api";
import wx from "jweixin-1.6.0";
import { getCosTempToken } from "../api";
import {generateQrcode} from "../api/axios/generate-qrcode";

export default {
  name: "pos_detail",
  computed: {
    poiSelectURL() {
      if (
        this.latitude != null &&
        this.latitude != 0 &&
        this.longitude != null &&
        this.longitude != 0
      )
        return (
          "https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=XZIBZ-MBCWP-VZ3D6-V2YPH-UVRCF-ARFRA&referer=ZMXCLMK&coordtype=5" +
          "&coord=" +
          this.latitude +
          "," +
          this.longitude
        );
      else
        return "https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=XZIBZ-MBCWP-VZ3D6-V2YPH-UVRCF-ARFRA&referer=ZMXCLMK";
    },
  },

  data() {
    return {
      zmEmployee: sessionStorage.getItem('zmEmployee'),  //众敏雇员权限
      selectPosition: false,
      provinces: [], //省
      citys: [], //市
      districts: [], //区
      currentProvince: "广东", //当前省份
      currentCity: "深圳", //当前城市
      currentDistrict: "南山区", //当前区

      fromnode: "",
      accessType: 1,
      accessTypeList: [
        {
          id: 1,
          name: "边缘接入",
        },
        {
          id: 2,
          name: "云端集成",
        },
        {
          id: 3,
          name: "入链导流",
        },
        {
          id: 4,
          name: "众敏核验",
        },
        {
          id: 5,
          name: "用户核验",
        },
        {
          id: 6,
          name: "自助录入",
        },
      ],
      callMethods: [{
        id: 0,
        name: '众敏边缘接入',
      },{
        id: 1,
        name: '5分钟云云对接',
      },{
        id: 2,
        name: '有车邦云云对接',
      },{
        id: 3,
        name: '人工方式，人工扫码，帮用户完成支付',
      },],
      callMethod: null,
      pos: "",
      openUpload: "",
      posImgs: [], //上传图片的列表
      cacheUrlImgs: [], //图片存储的url地址

      //   绑定当前填写的值
      posId: "",
      posName: "",
      partnerName: "",
      partnerId: sessionStorage.getItem("partnerid"), //默认使用众敏posId

      address: "",
      longitude: sessionStorage.getItem("mylng"),
      latitude: sessionStorage.getItem("mylat"),
      contact: "",
      phone: "",
      partnerList: [],

      beginHours: "00",
      beginMin: "00",
      endHours: "24",
      endMin: "00",
      openHours: "",

      deviceName: null,
      deviceToken: null,
      pubKey: "1",
      snOfPartnerId: "",

      cacheDeliveryUrl: [], //网点二维码
      deliveryUrl: "", //网点二维码
      deletImgList: [],  //图片删除后加入删除列表 ，在提交信息后统一删除

      listQrInfo: [], //门店现场二维码信息

      partnerChange: false
    }
  },
  watch: {
    posImgs: function () {
      if (this.openUpload) {
          this.getCos();
          let imgName = createUploadImgName(this.posId);
          let imgObj = this.posImgs[this.posImgs.length - 1].content;
          uploadImg(imgObj, imgName, this.saveImgUrl);
      }
    },
    beginHours: function () {
      if (this.beginHours.length === 2) {
        document.querySelector("#beginMin").focus();
      }
    },
    beginMin: function () {
      if (this.beginMin.length === 2) {
        document.querySelector("#endHours").focus();
      } else if (this.beginMin.length === 0) {
        document.querySelector("#beginHours").focus();
      }
    },
    endHours: function () {
      if (this.endHours.length === 2) {
        document.querySelector("#endMin").focus();
      } else if (this.endHours.length === 0) {
        document.querySelector("#beginMin").focus();
      }
    },
    endMin: function () {
      if (this.endMin.length === 0) {
        document.querySelector("#endHours").focus();
      }
    },
  },
  mounted() {
    if (this.$route.query.posId) {
      this.posId = this.$route.query.posId;
      // 查询网点商户信息
      this.getPartner();
      console.log("修改网点");
      this.queryPosInfo();
      this.queryPosQrCode();
    } else {
      console.log("新增网点");
      // 查询网点商户信息
      this.getPartner();
    }

    this.queryArea();
    this.getCos();


  },
  methods: {
    // 查询商户列表
    getPartner(){
      if(this.zmEmployee){
        getPartnerList().then((res) => {
          this.partnerList = res.data.queryPartner;
        }).catch(error => {
          alert(`查询商户列表异常：${error}`)
        });
      }else{
        findPartnerByPartnerId(sessionStorage.getItem('partnerid')).then(res => {
          this.partnerList.push(res.data.findPartnerByPartnerId);
        }).catch(error => {
          alert(`查询商户信息异常：${error}`)
        })
      }
    },

    // 获取cos权限
    getCos() {
      getCosTempToken("pos").then((res) => {
        console.log("获取costoken响应拦截", res.data);
        if (res.data.retcode == 0) {
          let data = res.data.data;
          console.log("请求token时的文件地址", data.pathPre);
          sessionStorage.setItem("cosPath", data.pathPre);
          console.log("从session中取出来的文件目录为", sessionStorage.getItem("cosPath"));
        }
      });
    },

    // 使用腾讯地图api取得位置
    fillPosition() {
      this.selectPosition = true;
      let that = this;
      window.addEventListener(
        "message",
        function (event) {
          // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
          let loc = event.data;
          if (loc && loc.module == "locationPicker") {
            //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
            console.log("location", loc);

            that.latitude = loc.latlng.lat;
            that.longitude = loc.latlng.lng;
            that.address = loc.poiaddress;

            let province = findMatch(that.address, that.provinces, true);
            if(province.name){
              that.currentProvince = province.name;
              that.changeProvince();
              let city = findMatch(that.address, that.citys, true);
              if(city.name){
                that.currentCity = city.name;
                that.changeCity();
                let district = findMatch(that.address, that.districts, false);
                if(district){
                  that.currentDistrict = district;
                }
              }
            }
            // console.log('当前省份为', that.currentProvince, that.currentCity, that.currentDistrict);

            that.selectPosition = false;
          }
        },
        false
      );
    },

    // 查询网点详细数据
    queryPosInfo() {
      let params = {
        posId: this.$route.query.posId,
      };
      queryPosDetailByPosId(params).then((res) => {
        console.log("查询网点详情", res);
        try {
          let data = res.data.findPosInfoByPosId;
          this.posId = data.pos.posId;
          this.posName = data.pos.name;
          this.fromnode = data.pos.fromnode;
          this.partnerId = data.pos.partnerId;
          this.accessType = data.pos.accessType;

          if(data.device){
            if (data.device.deviceName) {
              this.deviceName = data.device.deviceName;
            }
            if(data.device.token) {
              this.deviceToken = data.device.token;
            }
            if(data.device.snOfPartnerId){
              this.snOfPartnerId = data.device.snOfPartnerId;
            }
          }


          if (data.pos.province.indexOf("省")) {
            let reg = new RegExp("省");
            this.currentProvince = data.pos.province.replace(reg, "");
          } else {
            this.currentProvince = data.pos.province;
          }
          if (data.pos.city.indexOf("市")) {
            let reg = new RegExp("市");
            this.currentCity = data.pos.city.replace(reg, "");
          } else {
            this.currentCity = data.pos.city;
          }
          this.currentDistrict = data.pos.district;

          this.focusArea();

          this.address = data.pos.address;
          this.latitude = data.pos.latitude;
          this.longitude = data.pos.longitude;
          this.contact = data.pos.contact;
          this.phone = data.pos.phone;

          if (data.pos.openHoursV2 !== "" && data.pos.openHoursV2 !== null) {
            console.log("存在v2开放时间");
            this.beginHours = data.pos.openHoursV2.slice(0, 2);
            this.beginMin = data.pos.openHoursV2.slice(3, 5);
            this.endHours = data.pos.openHoursV2.slice(6, 8);
            this.endMin = data.pos.openHoursV2.slice(9);
            console.log(
              "时间",
              this.beginHours,
              this.beginMin,
              this.endHours,
              this.endMin
            );
          } else if (data.pos.openHours !== "" && data.pos.openHours !== null) {
            console.log("存在v1开放时间");
            this.beginHours = this.pos.openHours.slice(0, 2);
            this.beginMin = "00";
            this.endHours = this.pos.openHours.slice(2);
            this.endMin = "00";
          }


          if (data.posAdditionInfo) {
            if(data.posAdditionInfo.picUrl !== "null"){
              let posAddition = data.posAdditionInfo
              // 从字符串中取出图片并且去掉多余的引号
              let imgData = JSON.parse(posAddition.picUrl);
              for(const item of imgData){
                let imgUrl = {
                  url: item
                }
                this.posImgs.push(imgUrl);
                this.cacheUrlImgs.push(imgUrl.url);
              }
            }

            if(data.posAdditionInfo.deliveryUrl){
              let imgUrl = {
                url: data.posAdditionInfo.deliveryUrl
              }
              this.deliveryUrl = data.posAdditionInfo.deliveryUrl;
              this.cacheDeliveryUrl.push(imgUrl);
            }

            if(data.posAdditionInfo.callMethod !== '' && data.posAdditionInfo.callMethod !== null){
              this.callMethod = data.posAdditionInfo.callMethod;
            }
          } else if (data.pos.picture !== null) {
            let imgUrl = {
              url: data.pos.picture,
            };
            this.posImgs.push(imgUrl);
            this.cacheUrlImgs.push(imgUrl.url);
          }
          console.log("图片数组", this.posImgs);
        } catch (err) {
          alert(`queryPosDetailByPosId异常${err}`);
        }
      });
    },

    // 查询网点二维码
    queryPosQrCode() {
      let params = {
        posId: this.$route.query.posId
      }
      queryQrInfo(params).then(res => {
        console.log('查询二维码信息', res);
        let data = res.data.findByPosIdAndFromNode;
        if(data){
          for(const item of data){
            this.listQrInfo.push(item.qrUrl);
          }
        }
      }).catch(error => {
        alert(`查询二维码异常：${JSON.stringify(error)}`)
      })
    },

    // 上传网点图片
    getUploadImg(value) {
      this.openUpload = value;
    },

    // 保存图片url地址
    saveImgUrl(imgUrl) {
      this.cacheUrlImgs.push(imgUrl);

      console.log('当前图片url列表为', this.cacheUrlImgs);
    },

    deletDeliveryUrlImg(){
      this.deliveryUrl = "";
    },

    // 删除对应的图片
    deletImg(file,detail){
      console.log('删除的图片是', file, detail);
      this.openUpload = false;
      let index = detail.index;
      this.cacheUrlImgs.splice(index,1);
      this.deletImgList.push(file);
      console.log('删除后图片列表为', this.cacheUrlImgs);
      console.log('删除列表为', this.deletImgList);
    },

    // 修改商户
    changePartner() {
      console.log("修改商户");
      this.partnerChange = true;
    },

    // 查询全国省市区信息
    queryArea() {
      getArea().then((res) => {
        console.log("查询到全国省市区信息", res);
        this.provinces = res.data;
        this.citys = this.provinces[0].city;
        this.districts = this.citys[0].area;
        this.focusArea();
      });
    },

    // 重定向省市区
    focusArea() {
      for (const item of this.provinces) {
        if (item.name === this.currentProvince) {
          this.citys = item.city;
          this.districts = this.citys[0].area;
        }
      }
      for (const item of this.citys) {
        if (item.name === this.currentCity) {
          this.districts = item.area;
        }
      }
    },

    // 切换省份
    changeProvince() {
      for (const item of this.provinces) {
        if (item.name === this.currentProvince) {
          this.citys = item.city;
          this.currentCity = this.citys[0].name;
          this.districts = this.citys[0].area;
          this.currentDistrict = this.districts[0];
        }
      }
    },

    // 切换城市
    changeCity() {
      for (const item of this.citys) {
        if (item.name === this.currentCity) {
          this.districts = item.area;
          this.currentDistrict = this.districts[0];
        }
      }
    },

    // 重新定位
    Retargeting() {
      let that = this;
      wx.getLocation({
        type: "gcj02", //jssdk获取的坐标类型
        success: function (res) {
          sessionStorage.setItem("mylng", res.longitude);
          sessionStorage.setItem("mylat", res.latitude);
          that.$notify({
            icon: "success",
            message: "定位成功!",
          });
        },
        fail: function (res) {
          console.log("定位失败回调", res);
          that.$notify({
            icon: "cross",
            message: "定位失败!",
          });
        },
      });
    },
    // 提交网点
    submitPos() {
      console.log("提交网点");
      // 商户发生变化，触发商户迁移函数
      if(this.partnerChange){
        this.posMigrationPartner();
      }

      if (this.beginHours.length <= 1) {
        this.beginHours = "0" + this.beginHours;
      }
      if (this.beginMin.length <= 1) {
        this.beginMin = "0" + this.beginMin;
      }
      if (this.endHours.length <= 1) {
        this.endHours = "0" + this.endHours;
      }
      if (this.endMin.length <= 1) {
        this.endMin = "0" + this.endMin;
      }

      if (this.$route.query.posId) {
        console.log("修改网点");
        let params = this.createParams();
        console.log("当前修改后的数据", params);
        let openId = sessionStorage.getItem("openid");
        modPos(params, openId).then((res) => {
          console.log("修改网点返回值 ", res);
          if (res.data.retcode == 0) {
            alert("修改成功");
            for(const item of this.deletImgList){
              deletImgObject(item.url);
            }
            this.$router.push("/posList");
          } else {
            alert(`异常：${res.data.retmsg}`);
          }
        });
      } else {
        let params = this.createParams();
        console.log('添加网点时的参数列表',params);
        addPos(params).then((res) => {
          console.log("添加网点返回值 ", res);
          if (res.data.retcode == 0) {
            alert("新增成功");
            this.$router.push("/posList");
          } else {
            alert(`异常：${res.data.retmsg}`);
          }
        });
      }
    },

    // 创建参数列表
    createParams() {
      let params = {};
      if(this.$route.query.posId) {
        params.posId = this.$route.query.posId;
        params.name = this.posName;
        params.fromnode = this.fromnode;
        params.contact = this.contact;
        params.phone = this.phone;
        params.accessType = Number(this.accessType);
        params.openhoursV2 = `${this.beginHours}:${this.beginMin}-${this.endHours}:${this.endMin}`;
        params.address = this.address;
        params.province = this.currentProvince;
        params.city = this.currentCity;
        params.district = this.currentDistrict;
        params.longitude = this.longitude;
        params.latitude = this.latitude;
        params.lstPicUrls = this.cacheUrlImgs;
        params.deliveryUrl = this.deliveryUrl;

      }else {
        params.posInfo = {};
        params.posInfo.partnerId = this.partnerId;
        params.posInfo.name = this.posName;
        params.posInfo.fromnode = this.fromnode;
        params.posInfo.contact = this.contact;
        params.posInfo.phone = this.phone;
        params.posInfo.accessType = Number(this.accessType);
        params.posInfo.openhoursV2 = `${this.beginHours}:${this.beginMin}-${this.endHours}:${this.endMin}`;
        params.posInfo.address = this.address;
        params.posInfo.province = this.currentProvince;
        params.posInfo.city = this.currentCity;
        params.posInfo.district = this.currentDistrict;
        params.posInfo.longitude = this.longitude;
        params.posInfo.latitude = this.latitude;
        params.posInfo.lstPicUrls = this.cacheUrlImgs;
        params.posInfo.deliveryUrl = this.deliveryUrl;
      }

      params.deviceInfo = {};
      if(this.deviceName){
        params.deviceInfo.deviceName = this.deviceName;
      }
      if(this.deviceToken){
        params.deviceInfo.deviceToken = this.deviceToken;
      }
      if(this.pubKey){
        params.deviceInfo.pubKey = this.pubKey;
      }
      if(this.snOfPartnerId){
        params.deviceInfo.snOfPartnerId = this.snOfPartnerId;
      }

      params.posOtherInfo = {};
      if(this.callMethod !== null){
        params.posOtherInfo.callMethod = this.callMethod;
      }


      params.posOtherInfo.listQrInfo = this.listQrInfo;


      return params;
    },

  //   图片上传完成
    complateImg(){
      let cosPath = sessionStorage.getItem('cosPath');
      cosPath+='/qrCode';
      sessionStorage.setItem('cosPath',cosPath);
      console.log(sessionStorage.getItem('cosPath'));
      console.log('上传的图片是',this.cacheDeliveryUrl);
      let imgName = createUploadImgName(this.posId);
      let imgObj = this.cacheDeliveryUrl[this.cacheDeliveryUrl.length - 1].content;
      uploadImg(imgObj, imgName, this.savePosQrcode);
    },

    // 保存网点二维码图片
    savePosQrcode(imgUrl){
      this.deliveryUrl = imgUrl;
    },

    // 网点迁移商户
    posMigrationPartner(){
      let params = {
        posId: this.posId,
        partnerId: this.partnerId
      }
      modPosPartner(params).then(res => {
        if(res.data.retcode === 0){
          alert('网点商户迁移成功');
        }else{
          alert(`商户号迁移异常：${res.data.retmsg}`)
        }
      }).catch(error => {
        alert(`迁移网点异常：${error}`)
      })
    },

    // 扫一扫增加二维码
    scanQrCode(){
      let that = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          alert(`识别二维码成功：${result}`)
          that.listQrInfo.push(result);
        },
        fail: function (res) {
          alert(`打开微信扫一扫异常：${JSON.stringify(res)}`)
        }
      });
    },

    // 删除二维码
    deletQrCodeUrl(del_url_index){
     this.listQrInfo = this.listQrInfo.filter((item, index) => index != del_url_index);
    },

    getQrCode(item) {
      generateQrcode({
        cmd: 'autoStart',
        deviceID: item.pos.posId,
        pageNo: '25',
        agentID: 'ZMXCL'
      }).then(res => {
        console.log('生成门店二维码', res);
      }).catch(error => {
        console.log('生成门店二维码异常', error);
      })
    }
  }
}

</script>
<style src="../css/common.css"></style>
<style src="../css/pos_detail.css" scoped></style>



// WEBPACK FOOTER //
// src/views/pos_detail.vue